import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../dialogs/error-dialog/error-dialog.component';
import { EmployeeVisitOverlap } from 'src/api';

@Injectable()
export class ErrorDialogService {
  private opened = false;

  constructor(private dialog: MatDialog) {}

  openDialog(
    message: string,
    status?: number,
    overlapDay?: string,
    employeeVisitOverlaps?: EmployeeVisitOverlap[]
  ): void {
    if (!this.opened) {
      this.opened = true;
      const dialogRef = this.dialog.open(ErrorDialogComponent, {
        data: { message, status, overlapDay, employeeVisitOverlaps },
        maxHeight: '100%',
        width: 'auto',
        disableClose: true,
        hasBackdrop: true,
      });

      dialogRef.afterClosed().subscribe(() => {
        this.opened = false;
      });
    }
  }
}
